interface RetryBackoffOptions {
  initialDelayMs?: number;
  maxDelayMs?: number;
}

/**
 * Exponential backoff with equal jitter — the delay lands somewhere in [ceiling / 2, ceiling],
 * so a fleet of tabs reconnecting after an outage spreads its attempts out instead of stampeding
 * the service the moment it comes back, while the half-ceiling floor keeps retries off a hot loop.
 */
export const retryDelayForAttempt = (
  attempt: number,
  { initialDelayMs = 2000, maxDelayMs = 30000 }: RetryBackoffOptions = {}
) => {
  const ceiling = Math.min(
    initialDelayMs * 2 ** Math.max(attempt, 0),
    maxDelayMs
  );
  return ceiling / 2 + Math.random() * (ceiling / 2);
};
